import { Injectable } from '@angular/core';

import { Api } from '../api/api';
import { IISLETemplate, IRoute } from '../components/toolComponents/isle/isle.model';

@Injectable({
    providedIn: 'root'
})
export class IsleService {
    constructor(private readonly api: Api) { }

    public async getTemplates(userName ?: string, appEnvironment?: string): Promise<IISLETemplate[]> {
        return this.api.http2.get(`isle/templates/${[userName, appEnvironment].join('/')}`);
    }

    public async getSegments(county: string, route: string) {
        return this.api.http2.get(`isle/segments/${county}/${route}`);
    }

    public async getSegment(county: string, route: string, segment: string, template?: string, userName ?: string, usecrsforislebot?: boolean, appEnvironment?: string): Promise<IRoute> {
        if (!usecrsforislebot) {
            template = (template) ? '?templateName=' + encodeURI(template) : '';
            return this.api.http2.get(`isle/segments/${county}/${route}/${segment}${template}/${appEnvironment}`);
        } else {
            if (!template) {template = '' ; }
            return this.api.http2.get(`isle/segments/${county}/${route}/${segment}/${userName}/${template}/${appEnvironment}`);
        }
    }
}
